import { useApi } from "../../components/ui";

export interface Option {
  id: string;
  name: string;
}

/** Pickers used across staff pages (customers, staff users, projects). */
export function usePickers() {
  const orgs = useApi<{ orgs: Array<{ id: string; name: string; archived: number }> }>("/staff/orgs");
  const users = useApi<{ users: Array<{ id: string; email: string; name: string }> }>("/staff/staff-users");
  const projects = useApi<{ projects: Array<{ id: string; name: string; orgName: string | null; status: string }> }>("/staff/projects");
  return {
    orgs: (orgs.data?.orgs ?? []).filter((o) => !o.archived).map((o) => ({ id: o.id, name: o.name })),
    users: (users.data?.users ?? []).map((u) => ({ id: u.id, name: u.name || u.email })),
    projects: (projects.data?.projects ?? []).map((p) => ({ id: p.id, name: p.orgName ? `${p.name} (${p.orgName})` : p.name, status: p.status })),
  };
}
